

jQuery(function(){

    function cl(words) {
        console.log('Story_Box.js: ' + words);
    }

    function ol(object, words = '') {
        cl(words + object + ': \\/');
        console.log(object);
    }

    let $ = jQuery;

    class StoryBox  {

        //index = 0;
        lastIndex = 0;
        newIndex = 0;
        indexQueue = [];
        scrolling = false;
        indexedPois = {};
        allPoimaps = null;
        thumbs = null;
        animTime = 300;

        constructor (parentDiv, idx) {
            //cl('Story_Box ENTERING');

            // referencing everything
            const ths = this;
            const thsObj = $(this);

            this.parentDiv = parentDiv;
            this.mapViewDiv = $(parentDiv.find('.drx_osf_story_mapview')[0]);
            this.mapImgRow = $(parentDiv.find('.map-image-row')[0]);
            this.mapPartTextDiv = $(parentDiv.find('.part-infos')[0]);
            this.infos = $(this.mapPartTextDiv).find('.info');
            this.closeBtn = $(parentDiv.find('.btn-close-mapview')[0]);
            this.bkwdBtn = $(parentDiv.find('.btn-bkwd')[0]);
            this.fwdBtn = $(parentDiv.find('.btn-fwd')[0]);
            this.mapCtr = $(parentDiv.find('.ratio-fixer > .mapp-layout')[0]);
            this.poimapBtn = $(parentDiv.find('.btn-poimap')[0]);
            this.poimapRow = $(parentDiv.find('.poimap-row')[0]);
            this.gmap = window['mapp'+idx];
            this.zoom = 10;
            this.googlmap = this.gmap.getMap();
            this.googlmap.setZoom(this.zoom);
            this.pois = this.gmap.getPois();
            this.allPoimaps = this.poimapRow.find('.part-poimap');
            this.thumbs = this.mapImgRow.children('.part-image');
            this.width = window.innerWidth;

            //ol(ths, 'ths');
            //ol(this.indexQueue, 'indexQueue');
            //ol(this.googlmap, 'googlmap');
            //ol(this.gmap, 'gmap');
            //ol(this.mapImgRow, 'mapImgRow');
            //ol(this.pois, 'pois');

            // what images have pois?
            this.thumbs.each(function(thmbsIdx, thmb) {
                ths.pois.forEach((poi) => {
                    if ($(thmb).data('poi-lat') == poi.getPosition().lat() && $(thmb).data('poi-lng') == poi.getPosition().lng()) {
                        //ol(poi, 'fitting poi');
                        ths.indexedPois[thmbsIdx] = poi;
                    }
                });
                $(thmb).click((e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    ths.buildViewImgFocus(thmbsIdx);
                    ths.mapImgRow.removeAttr('style');
                });
            });

            // sharpening ...
            // ... the cards
            this.parentDiv.find('.story-card-tainer > .card').click( function(e) {
                e.preventDefault();
                e.stopPropagation();
                ths.buildViewImgFocus($(this).data('index'));
            });

            // ... stopping on map ...
            this.mapCtr.click((e) => {
                e.preventDefault();
                e.stopPropagation();
            });

            // ... stopping on textboxes ...
            this.infos.click((e) => {
                e.preventDefault();
                e.stopPropagation();
            });

            // ... the close button ...
            this.closeBtn.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                this.mapViewDiv.addClass('d-none');
            });

            // ... the whole background ...
            this.mapViewDiv.click((e) => {
                //e.preventDefault();
                //e.stopPropagation();
                this.mapViewDiv.addClass('d-none');
            });

            // ... the bakcward button ...
            this.bkwdBtn.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                this.queueUp(this.lastIndex - 1);
            });

            // ... the forward button ...
            this.fwdBtn.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                this.queueUp(this.lastIndex + 1);
            });

            // ... the poimap button triggers map-focus ...
            this.poimapBtn.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                ths.viewMapFocus();
            });

            // ... stoppin propagation on mapImgRow
            this.mapImgRow.click((e) => {
                e.preventDefault();
                e.stopPropagation();
            });

        } // StoryBox constructor


        resize = () => {
            // force a rebuild of layout;
            this.width = window.innerWidth;
            this.queueUp(this.lastIndex);
        };

        viewMapFocus() {
            this.mapViewDiv.removeClass('image-focus');
            this.mapViewDiv.addClass('map-focus');
            //this.gmap.recenter();
            this.centerMap();
            this.moveImgRow();
        };

        queueUp(nextIndex) {
            if (nextIndex >= 0 &&  nextIndex < this.thumbs.length) {
                this.indexQueue.push(nextIndex);
                if (! this.scrolling) {
                    this.scrolling = true;
                    this.changeIndex();
                }
            }
        };

        centerMap = (index=-1) => {
            if (-1 == index) index = this.lastIndex;
            let poi = this.indexedPois[index];
            ol(poi, 'ein poi');
            poi.center();
            poi.open();
            this.googlmap.setZoom(this.zoom);
        };

        changeIndex = () => {
            //ol(this.indexQueue, 'changeIndex indexQueue');

            // getting netx index from queue
            if (this.indexQueue.length != 0) {

                this.newIndex = this.indexQueue.shift();

                cl('changeIndex newIndex:' + this.newIndex);

                this.thumbs.removeClass('actual');
                this.thumbs.eq(this.newIndex).addClass('actual');

                if (this.newIndex == 0) this.bkwdBtn.addClass('d-none');
                else                    this.bkwdBtn.removeClass('d-none');

                ol(this.thumbs, 'this.thumbs');

                if (this.newIndex == this.thumbs.length-1)    this.fwdBtn.addClass('d-none');
                else                                    this.fwdBtn.removeClass('d-none');

                if (this.mapViewDiv.hasClass('map-focus')) {
                    //cl('changeIndex - map-focus entered');

                    // move and adapt thumbs
                    // wait for end of transition
                    this.moveImgRow();
                    //cl('indexedPois: ' + indexedPois);
                    if (this.newIndex in this.indexedPois) {
                        this.centerMap(this.newIndex);
                    }
                    else {
                        this.gmap.close();
                        this.googlmap.setZoom(this.zoom - 1);
                    }
                }
                else if (this.mapViewDiv.hasClass('image-focus')) {
                    // move poimap row
                    let actualPoimap = $(this.allPoimaps[this.lastIndex]);
                    this.mapImgRow.offset({left: 0});
                    //ol(actualPoimap, 'actualPoimap');
                    this.poimapRow.offset({left: (-this.newIndex * (actualPoimap.width())) + this.poimapBtn.offset().left});
                    this.allPoimaps.removeClass('actual');
                    $(this.allPoimaps[this.newIndex]).addClass('actual');
                }

                //ol(infos, 'infos: ');
                // move text
                let infoCtrLeft = this.mapPartTextDiv.offset().left;
                let newLeft = (infoCtrLeft - this.infos.eq(this.newIndex).offset().left);

                //cl('new info left: ' + newLeft);

                this.mapPartTextDiv.offset({left: newLeft});

                // remember index ...
                this.lastIndex = this.newIndex;
                setTimeout(this.changeIndex, this.animTime + 100);
            }
            else
                this.scrolling = false;
        };


        moveImgRow() {
            let rowLeft = this.mapImgRow.offset().left;
            let thumbLeft = this.thumbs.eq(this.newIndex).offset().left;
            thumbLeft = thumbLeft + (this.thumbs.eq(this.newIndex).width() / 2);

            let diffLeft = (0.5 * this.width) - thumbLeft;
            let newLeft = rowLeft + diffLeft;

            // adjust to 17px margin
            if (diffLeft > 0)
                newLeft = newLeft - 17;
            else
                newLeft = newLeft + 17;
            this.mapImgRow.animate({left: newLeft}, this.animTime);
        }


        buildViewImgFocus(nextIndex) {
            //ol(nextIndex, 'nextIndex');

            if (this.mapViewDiv.hasClass('map-focus') || this.mapViewDiv.hasClass('d-none')) {
                this.mapViewDiv.removeClass('d-none');
                this.mapViewDiv.removeClass('map-focus');
                this.mapViewDiv.addClass('image-focus');
                this.queueUp(nextIndex);
            }
            else
                this.queueUp(nextIndex);
        }

    } // function Story_Box


    // put js-class on every storybox
    let boxes = $('.drx-osf-blck-story');
    //ol(boxes, 'boxes');
    let allBoxes = [];

    boxes.each((idx, box) => {
        //ol(box, 'box');
        allBoxes[idx] = new StoryBox($(box), idx);
    });

    $(window).resize(() => {
        // kind of force a layout reset
        cl('resetting storybox layout');
        allBoxes.forEach((box) => {box.resize()});
    });

});